import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CustomersService from '../services/customers.service';
import { displayAlert } from './feedbackSlice';
import { manageError, removeObjectWithId, replaceObjectWithId } from '../utils/helpers';

export const getCustomers = createAsyncThunk(
  'customers/list',
  async (thunkAPI) => {
    try {
      const data = await CustomersService.getCustomers();
      return { customers: data.data };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const createCustomer = createAsyncThunk(
  'customers/post',
  async (customerData, thunkAPI) => {
    try {
      const data = await CustomersService.createCustomer(customerData);
      return { customer: data.data };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const updateCustomer = createAsyncThunk(
  'customers/patch',
  async ({ customerId, customerData }, thunkAPI) => {
    try {
      const data = await CustomersService.updateCustomer(customerId, customerData);
      return { customer: data.data };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const deleteCustomer = createAsyncThunk(
  'customers/delete',
  async (customer, thunkAPI) => {
    try {
      await CustomersService.deleteCustomer(customer.id);
      return { customer };
    } catch (error) {
      const message = manageError(error);
      thunkAPI.dispatch(displayAlert(message, 'error'));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const customersSlice = createSlice({
  name: 'customers',
  initialState: {
    customers: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomers.fulfilled, (state, action) => {
      state.customers = action.payload.customers;
    });
    builder.addCase(getCustomers.rejected, (state, action) => {
      state.customers = [];
    });
    builder.addCase(createCustomer.fulfilled, (state, action) => {
      // Rajouter un membre retiré le RÉINSCRIT : l'API rend la fiche
      // existante, pas une nouvelle. L'ajouter en bout de liste la ferait
      // apparaître deux fois tant que l'écran n'est pas rechargé.
      const { customer } = action.payload;
      const known = state.customers.some((existing) => existing.id === customer.id);
      state.customers = known
        ? replaceObjectWithId([...state.customers], customer)
        : [...state.customers, customer];
    });
    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.customers = replaceObjectWithId([...state.customers], action.payload.customer);
    });
    builder.addCase(deleteCustomer.fulfilled, (state, action) => {
      state.customers = removeObjectWithId([...state.customers], action.payload.customer);
    });
  },
});

export default customersSlice.reducer;
